// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { keycloak } from "../main.ts";
import { getSafeRedirect } from "../utils/GeneralUtils.ts";
import Home from "../views/Home.vue";
import Products from "../views/Products.vue";
import Projects from "../views/Projects.vue";
import Privacy from "../views/Privacy.vue";
import LanguageOverview from "../views/LanguageOverview.vue";
import ReleaseNotes from "../views/ReleaseNotes.vue";
import UserManualPage from "../views/UserManualPage.vue";
import PdfViewer from "../views/PdfViewer.vue";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/products",
        name: "Products",
        component: Products,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/projects",
        name: "Projects",
        component: Projects,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: Privacy,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/language-overview",
        name: "LanguageOverview",
        component: LanguageOverview,
        meta: {
            requiresAuth: false,
        },
    },
    {
        // Public: customers (and anyone) can read what changed without logging in (RDT-286).
        path: "/release-notes",
        name: "ReleaseNotes",
        component: ReleaseNotes,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/manual",
        name: "UserManual",
        component: UserManualPage,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/pdf-viewer",
        name: "PdfViewer",
        component: PdfViewer,
        meta: {
            requiresAuth: true,
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;

router.beforeEach((to, _, next) => {
    if (to.meta.requiresAuth && !keycloak.authenticated) {
        localStorage.removeItem("newAccount");

        const safeRedirect = getSafeRedirect(globalThis.location.href);
        keycloak.login({ redirectUri: safeRedirect });
        return;
    }
    next();
});

router.afterEach(() => {
    if (globalThis.location.hash) {
        const url = new URL(globalThis.location.href);
        url.hash = "";
        globalThis.history.pushState({}, "", url);
    }
});
